import { head, isEmpty } from 'lodash/fp';

import { CmsInsuranceTypeContent, SectionOfferStrip } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';

type Props = {
  cmsSectionContent?: CmsInsuranceTypeContent['offer'] | null;
};

const mapOffer = ({ cmsSectionContent }: Props) => {
  const offer = head(cmsSectionContent);
  if (isEmpty(offer) || !offer.descriptionRaw) {
    return null;
  }
  const offerContent: SectionOfferStrip = {
    footnote: {
      linkId: offer.footnoteLinkSymbol ? `footnote-${offer.footnoteLinkSymbol}` : null,
      reference: offer.footnoteLinkSymbol || null,
    },
    image: {
      alt: offer.icon?.caption || null,
      src: offer.icon?.image?.asset?.url || null,
    },
    title: offer.descriptionRaw,
    type: CONTENT_SECTIONS.OFFER_STRIP,
  };
  return offerContent;
};

export default mapOffer;
